import { cpf, cnpj } from "cpf-cnpj-validator";
import dayjs from "dayjs";
import { addMethod, date, string } from "yup";
import i18n from "../i18n";

addMethod(string, "validateCpf", function validateCpf() {
  return this.test({
    name: "isValidCPF",
    message: (value) => {
      const doc = (value.value as string) || "";
      return doc.length !== 14
        ? i18n.t("validation.cpfLength")
        : i18n.t("validation.cpfInvalid");
    },
    test: (value) => cpf.isValid(value || ""),
  });
});

addMethod(string, "validateCnpj", function validateCnpj() {
  return this.test({
    name: "isValidCNPJ",
    message: i18n.t("validation.cnpjInvalid"),
    test: (value) => cnpj.isValid(value || ""),
  });
});

addMethod(string, "validatePassword", function validatePassword() {
  return this.matches(/^.{8,16}$/, "minMaxError")
    .matches(/^(?=.*[A-Z])/, "uppercaseLetterError")
    .matches(/^(?=.*[a-z])/, "lowercaseLetterError")
    .matches(/^(?=.*\d)/, "digitsError")
    .matches(/^(?=.*[@;#$,.])/, "specialCharError");
});

addMethod(date, "dayjsDate", function dayjsDate() {
  return this.test({
    name: "dayjsDate",
    message: () => i18n.t("validation.invalidBirthDate"),
    test: (value) => {
      return value && dayjs().diff(dayjs(value), "year") >= 18;
    },
  });
});

addMethod(string, "validateFullName", function validateFullName() {
  return (
    this.matches(/^[\p{L}]{2,}/u, "minFirstNameError")
      .matches(/^[\p{L}]{2,}\s[\p{L}]{2,}/u, "minTwoNameError")
      .matches(/^[\p{L}]{2,}(\s[\p{L}]{2,})+$/u, "minThereNameError")
  );
});

addMethod(string, "validateEmail", function validateEmail() {
  return this.matches(/^[\w.+-]+@[a-zA-Z0-9.-]{3,}/i, "isDomainError")
      .matches(/\..{3,}$/i, "isDotComError");
});
